export class UpdateUserDatas {
  static readonly type = '[User] UpdateDatas';
  constructor(public payload: any) {}
}

export class SetUserDatas {
  static readonly type = '[User] SetDatas';
  constructor(public payload: any) {}
}

export class GetUser {
  static readonly type = '[User] Get';
  constructor() {}
}
